import React from 'react';
import {FieldValues} from 'react-hook-form';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';
import {FILTERS_KEPT_NONE} from 'shared/lib/filterHelper';

import MonitorsExportFormHandler, {IMonitorsExportFormHandlerProps} from './MonitorsExportFormHandler';

interface IMonitorsExportModalProps<T extends FieldValues> extends IMonitorsExportFormHandlerProps<T> {
    open: boolean,
    header: string,
}

function MonitorsExportModal<T extends FieldValues>({open, header, ...formProps}: IMonitorsExportModalProps<T>) {
    return (
        <FiltersModal
            header={header}
            open={open}
            handleClose={formProps.handleClose}
            keepParams={FILTERS_KEPT_NONE}
            withReset={false}
        >
            <MonitorsExportFormHandler<T> {...formProps}/>
        </FiltersModal>
    );
}

export default MonitorsExportModal;
